import { makeStyles } from '@material-ui/core';
import React from 'react';
import { Package, PlusSquare } from 'react-feather';
import { Link } from 'react-router-dom';
import { usePrefixTranslation } from '../../i18n';
import { theme } from '../../theme/theme';
import { Button } from '../global';
import { ProjectCalendar } from '../project/common/ProjectCalendar';
import { PastDuePsm } from './metrics/PastDuePsm';
import { RiskProfile } from './metrics/RiskProfile';
import { ScheduleAdherence } from './metrics/ScheduleAdherence';
import { StatusCounts } from './metrics/StatusCounts';
import { StatusProgression } from './metrics/StatusProgression';

const useDashboardClasses = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        background: theme.colors.neutral[6],
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 20,
        padding: '30px 30px 150px',
        background: theme.colors.darkBlue[1],
        '& > a': {
            textDecoration: 'none',
        },
        '& > a > button': {
            color: `${theme.colors.white} !important`,
            whiteSpace: 'nowrap',
        },
    },
    labels: {
        display: 'flex',
        flexDirection: 'column',
        '& > span:first-child': {
            color: theme.colors.white,
            ...theme.typography.page.title,
        },
        '& > span:last-child': {
            color: theme.colors.neutral[3],
            ...theme.typography.content.label.default,
        },
    },
    cards: {
        display: 'grid',
        gridTemplateRows: 'auto auto 1fr',
        gridTemplateColumns: '5fr 3fr 3fr',
        gap: 20,
        padding: 30,
        marginTop: -130,
        gridTemplateAreas: `"a b c" "d d e" "f f e"`,
        '& > div': {
            display: 'flex',
            flexDirection: 'column',
        },
        '& > div > div': {
            flex: 1,
        },
    },
    [`@media (max-width: ${theme.breakpoints.medium.max}px)`]: {
        cards: {
            gridTemplateRows: 'auto auto auto 1fr',
            gridTemplateColumns: '5fr 3fr',
            gridTemplateAreas: '"a b" "e c" "d d" "f f"',
        },
    },
    [`@media (max-width: ${theme.breakpoints.small.max}px)`]: {
        cards: {
            gridTemplateRows: 'auto',
            gridTemplateColumns: '1fr',
            gridTemplateAreas: '"a" "b" "c" "e" "d" "f"',
        },
    },
});

/**
 * Dashboard page contents.
 */
export const Dashboard = () => {
    const classes = useDashboardClasses();
    const { t } = usePrefixTranslation('dashboard', { dashboard: 'Dashboard' });

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <div className={classes.labels}>
                    <span>{t('title', { name: 'Corey' })}</span>
                    <span>{t('subtitle', { location: 'GP Brewton Mill' })}</span>
                </div>
                <div style={{ flex: 1 }} />
                <Link to='/plans/create'>
                    <Button startIcon={<PlusSquare />}>{t('button-new-plan')}</Button>
                </Link>
                <Link to='/assets'>
                    <Button startIcon={<Package />}>{t('button-assets')}</Button>
                </Link>
            </div>
            <div className={classes.cards}>
                <div style={{ gridArea: 'a' }}>
                    <RiskProfile />
                </div>
                <div style={{ gridArea: 'b' }}>
                    <PastDuePsm />
                </div>
                <div style={{ gridArea: 'c' }}>
                    <ScheduleAdherence />
                </div>
                <div style={{ gridArea: 'd' }}>
                    <StatusCounts />
                </div>
                <div style={{ gridArea: 'e' }}>
                    <StatusProgression />
                </div>
                <div style={{ gridArea: 'f', height: 600 }}>
                    <ProjectCalendar />
                </div>
            </div>
        </div>
    );
};
